import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import getTimeDiff from 'shared/utils/getTimeDiff';
import { stopConsultation, stopConsultationReconnectionFailed } from 'modules/conference/actions/stopConsultation';

import ReconnectionPlaceholder from './ReconnectionPlaceholder';

const RECONNECT_TIMEOUT = 60;

const mapStateToProps = (state) => ({
  reconnectionTime: state.conference.consultationLifecycle.reconnectionTime,
});

const mapDispatchToProps = (dispatch) => ({
  reconnectConnection: () => {
    if (/RnUmmanu/.test(navigator.userAgent)) {
      window.ReactNativeWebView?.postMessage(JSON.stringify({
        action: 'STOP_CONSULTATION',
      }));
    }

    navigator.onLine
      ? dispatch(stopConsultation({ consultationFailed: true }))
      : dispatch(stopConsultationReconnectionFailed());
  },
});


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

  lifecycle({
    componentDidMount() {
      const updateReconnectionTimerValue = () => {
        const { reconnectionTime, reconnectConnection } = this.props;
        if (this.state && this.state.reconnectionTimerValue === 0) {
          reconnectConnection();
          clearInterval(this.timer);
        }

        const reconnectionTimerValue = Math.max(0, RECONNECT_TIMEOUT - getTimeDiff(reconnectionTime));

        this.setState({ reconnectionTimerValue });
      };
      this.timer = setInterval(updateReconnectionTimerValue, 1000);
      updateReconnectionTimerValue();
    },
    componentWillUnmount() {
      clearInterval(this.timer);
    },
  }),
)(ReconnectionPlaceholder);
